import { render, staticRenderFns } from "./LmProcessHistory.vue?vue&type=template&id=0c2cb012&scoped=true"
import script from "./LmProcessHistory.vue?vue&type=script&lang=js"
export * from "./LmProcessHistory.vue?vue&type=script&lang=js"
import style0 from "./LmProcessHistory.vue?vue&type=style&index=0&id=0c2cb012&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2cb012",
  null
  
)

export default component.exports